import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from ".";
import Footer from "../Footer";

const categories = [
  {
    name: "Fruits",
    icon: "fas fa-apple-alt",
  },
  {
    name: "Vegetables",
    icon: "fas fa-carrot",
  },
  {
    name: "Meat and Fish",
    icon: "fas fa-drumstick-bite",
  },
  {
    name: "Snacks",
    icon: "fas fa-cookie",
  },
  {
    name: "Dairy and Milk",
    icon: "fas fa-cheese",
  },
  {
    name: "Oil and Masala",
    icon: "fas fa-oil-can",
  },
];

const CategoryRoute =( targetValue ) => {
  console.log(targetValue);
  return (
    <Router>
      <Header />
      <Switch>
        <Route exact path={"/categories/" + targetValue }>
          <h1>Hello i m {targetValue}</h1>
        </Route>
      </Switch>
      <Footer />
    </Router>
  );
}

export { categories, CategoryRoute };
